import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/toaster';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import ApprovalPendingPage from './pages/ApprovalPendingPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import SharedFilePage from './pages/SharedFilePage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/approval-pending" element={<ApprovalPendingPage />} />
          <Route path="/files/:id" element={<SharedFilePage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requireApproval={true}>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute requireApproval={true}>
                <AdminPage />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
